import React, { Component } from "react";
import IntelligentHeader from "./components/IntelligentHeader";
import IntelligentContent from "./components/IntelligentContent";
import "./style.css";
import "../../../../../index.css";
class IntelligentAllMajorModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      css: {},
    };
  }
  componentDidMount() {
    this.fixCss();
  }
  render() {
    const { allMajorData, visible, handleVisibleAllMajor,handleInlineVisibleMajor } = this.props;
    return (
      <div
        style={{ minHeight: this.state.css.minHeight }}
        className={
          visible === true
            ? "intelligentAllMajorModal_box"
            : "intelligentAllMajorModal_box display_none"
        }
      >
        <IntelligentHeader
          handleVisible={handleVisibleAllMajor}
        ></IntelligentHeader>
        {allMajorData != null ? (
          <IntelligentContent handleInlineVisibleMajor={handleInlineVisibleMajor} item={allMajorData}></IntelligentContent>
        ) : (
          ""
        )}
      </div>
    );
  }
  fixCss = () => {
    let minHeight = window.innerHeight;
    this.setState({
      css: {
        minHeight: minHeight,
      },
    });
  };
}

export default IntelligentAllMajorModal;



// WEBPACK FOOTER //
// ./src/containers/IntelligentBigData/IntelligentBigDataHome/components/IntelligentAllMajorModal/index.js